import { useUser } from './User';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { LoginFormMobile } from './components/LoginFormMobile';
import loginBackgroundImage from '../../assets/images/login-background.webp';
import { ReactComponent as Logo } from '../../assets/images/svg/logo512.svg';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export const LoginMobile = () => {
  const { user } = useUser();
  const history = useHistory();

  useEffect(() => {
    if (user) {
      history.push('/validar-contacto', { from: history?.location?.state?.from || '' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <>
      {!user && (
        <Grid container>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            sx={{
              width: '100vw',
              height: '100vh',
              position: 'fixed',
              top: 0,
              left: 0,
              flexBasis: { xs: '100vw', sm: '100vw', md: '100vw' },
              maxWidth: { xs: '100vw', sm: '100vw', md: '100vw' },
              minHeight: '100vh',
              maxHeight: '100vh',
              flexGrow: '0',
              flexShrink: '0',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
            }}
          >
            <Box
              sx={{
                height: '50%',
                backgroundImage: `url(${loginBackgroundImage})`,
                // backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 0) 60%, rgba(255, 255, 255, 1) 100%), url(${loginBackgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
                paddingTop: '32px',
              }}
            >
              <Logo
                style={{
                  width: '100px',
                  height: 'auto',
                  filter: 'drop-shadow(1px 0px 2px rgba(0, 0, 0, 0.5))',
                }}
              />
              <Typography content='h1' fontSize='1.9rem' color='#316527'>
                Mi OSER
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={12}
            sx={{
              width: '100vw',
              height: '100vh',
              position: 'fixed',
              top: '25%',
              left: '50%',
              transform: 'translateX(-50%)',
              flexBasis: { xs: '100vw', sm: '100vw', md: '100vw' },
              maxWidth: { xs: '100vw', sm: '80vw', md: '60vw' },
              minHeight: '100vh',
              maxHeight: '100vh',
              flexGrow: '0',
              flexShrink: '0',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
            }}
          >
            <Card
              sx={{
                boxShadow: 'initial',
                borderRadius: '0',
                background: 'linear-gradient(#f5f5f500, #f5f5f5b3)',
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <LoginFormMobile />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}
    </>
  );
};
